import React, { useEffect, useState } from "react";
import {
 getEmployerDashboardStats,
  getEmployerRecentJobs,
  getEmployerLatestApplications,
  getEmployerDashboardContext,
} from "../api/employerAPI/employerDashboardApi"; 


const Home = () => {
  const token = localStorage.getItem("otoken");
  const companyId = localStorage.getItem("companyId");

  const [stats, setStats] = useState({
    activeJobs: 0,
    totalApplications: 0,
    shortlisted: 0,
    interviewsThisWeek: 0,
  });

  const [recentJobs, setRecentJobs] = useState([]);
  const [latestApplications, setLatestApplications] = useState([]);

  useEffect(() => {
 if (!token || !companyId) return;

  getEmployerDashboardStats(token, companyId).then(setStats);
  getEmployerRecentJobs(token, companyId).then(setRecentJobs);
  getEmployerLatestApplications(token, companyId).then(setLatestApplications);

}, [token,companyId]);

  return (
    <div className="content-body">

            <div className="container-fluid mt-3">
                <div className="row justify-content-center">
                    <div className="col-lg-3 col-sm-6">
                        <div className="card gradient-1">
                            <div className="card-body">
                                <h3 className="card-title text-white">Total Applications</h3>
                                <div className="d-inline-block">
                                    <h2 className="text-white">{stats.totalApplications}</h2>
                                    <p className="text-white mb-0">All Time</p>
                                </div>
                                <span className="float-right display-5 opacity-5"> <i className="fa fa-file-text"></i></span>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3 col-sm-6">
                        <div className="card gradient-2">
                            <div className="card-body">
                                <h3 className="card-title text-white">Active Jobs</h3>
                                <div className="d-inline-block">
                                    <h2 className="text-white">{stats.activeJobs}</h2>
                                    <p className="text-white mb-0">Currently Open</p>
                                </div>
                                  <span className="float-right display-5 opacity-5">
                                    <i className="fa fa-briefcase"></i>
                                    </span>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3 col-sm-6">
                        <div className="card gradient-3">
                            <div className="card-body">
                                <h3 className="card-title text-white">Shortlisted</h3>
                                <div className="d-inline-block">
                                    <h2 className="text-white">{stats.shortlisted}</h2>
                                    <p className="text-white mb-0">Candidates</p>
                                </div>
                                <span className="float-right display-5 opacity-5">
                                <i className="fa fa-user-check"></i>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3 col-sm-6">
                        <div className="card gradient-4">
                            <div className="card-body">
                                <h3 className="card-title text-white">Interview This Week</h3>
                                <div className="d-inline-block">
                                    <h2 className="text-white">{stats.interviewsThisWeek}</h2>
                                    <p className="text-white mb-0">Scheduled</p>
                                </div>
                                <span className="float-right display-5 opacity-5"><i className="fa fa-calendar"></i></span>
                            </div>
                        </div>
                    </div>
                </div>

         
                

             
              

                <div className="row">
                    <div className="col-lg-6">
                        <div className="card">
        <div className="card-body">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h4 className="mb-0">Recent Job Posts</h4>
            <a href="employer/job-management/all-jobs">View all</a>
          </div>

            {recentJobs.length === 0 && (
              <p className="text-muted">No jobs posted yet</p>
            )}

            {recentJobs.map((job) => (
              <div
                key={job.job_id}
                className="d-flex justify-content-between align-items-center border-bottom py-3"
              >
                <div>
                  <h5 className="mb-1">{job.job_code} - {job.title}</h5>
                  <small className="text-muted">
                    {job.job_location} · {job.job_type} · {job.experience}
                  </small>
                </div>

                <div className="text-right">
                  <span
                    className={`badge ${
                      job.status === "Active" ? "badge-success" : "badge-secondary"
                    }`}
                  >
                    {job.status}
                  </span>
                  <div className="text-muted mt-1">
                    {job.applicationsCount} applications
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
                        
                    </div>
                    <div className="col-lg-6">
                       <div className="card">
  <div className="card-body">
    <div className="d-flex justify-content-between align-items-center mb-3">
      <h4 className="mb-0">Latest Applications</h4>
      <a href="employer/applications/view">View all</a>
    </div>

    <div className="table-responsive">
      <table className="table mb-0">
        <thead>
          <tr>
            <th>Candidate</th>
            <th>Job</th>
            <th>Applied</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {latestApplications.length === 0 && (
            <tr>
              <td colSpan="4" className="text-center text-muted">
                No applications yet
              </td>
            </tr>
          )}

          {latestApplications.map((app) => (
            <tr key={app.application_id}>
              <td>
                <strong>{app.candidate_name}</strong>
                <div className="text-muted small">
                  {app.candidate_title}
                </div>
              </td>

              <td>{app.job_code}</td>

              <td>
                {new Date(app.created_at).toLocaleDateString()}
              </td>

              <td>
                <span
                  className={`badge ${
                    app.status === "Shortlisted"
                      ? "badge-primary"
                      : app.status === "Review"
                      ? "badge-warning"
                      : "badge-secondary"
                  }`}
                >
                  {app.status}
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
</div>
                 
                    </div>
                </div>

               

                

            </div>
        </div>
  );
};

export default Home;
